import { useEffect, useState } from "react"
import { useTouUrlMutation, useUmsUrlMutation } from "./jguApi"

import { useAuth } from "../../../../modules/auth"

export const useGetTouUrl = () => {
    const { user } = useAuth()
    const [getTouUrl] = useTouUrlMutation()
    const [touUrl, setTouUrl] = useState<string>()

    useEffect(() => {
        if (!user || !user.email) return

        getTouUrl({
            email: user.email
        })
            .unwrap()
            .then((data) => setTouUrl(data.url))

        // eslint-disable-next-line
    }, [user])

    return { touUrl }
}

export const useUmsUrl = () => {
    const { user } = useAuth()
    const [getTouUrl] = useUmsUrlMutation()
    const [umsUrl, setUmsUrl] = useState<string>()

    useEffect(() => {
        if (!user || !user.email) return

        getTouUrl({
            registrationId: user.userName,
            email: user.email
        })
            .unwrap()
            .then((data) => setUmsUrl(data.url))

        // eslint-disable-next-line
    }, [user])

    return { umsUrl }
}